import * as RadixTooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";

import styles from "./content.module.css";

type Props = RadixTooltip.TooltipContentProps;

const Content = (props: Props) => {
    const { children, className, collisionPadding = 8, sideOffset = 8, ...rest } = props;

    return (
        <RadixTooltip.Portal>
            <RadixTooltip.Content
                data-testid="tooltip-content"
                collisionPadding={collisionPadding}
                sideOffset={sideOffset}
                className={clsx(styles.tooltip_content, className)}
                {...rest}
            >
                {children}
            </RadixTooltip.Content>
        </RadixTooltip.Portal>
    );
};

Content.displayName = "Tooltip.Content";

export { Content };
export type { Props as ContentProps };
